export default function (element, { threshold = 0 } = {}) {
    const { top, right, bottom, left, width, height } = element.getBoundingClientRect();

    const dim = {
        t: bottom,
        r: window.innerWidth - left,
        b: window.innerHeight - top,
        l: right
    };

    const th = {
        x: threshold * width,
        y: threshold * height
    };

    return dim.t > th.y
        && dim.r > th.x
        && dim.b > th.y
        && dim.l > th.x;
}
